<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Incumplimiento de entrega de proveedores</h1>
                <div class="caption">
                    Muestra el ABC de proveedores ordenándolos por cantidad de pedidos, por empresa y por periodo seleccionados para
                    los pedidos no entregados y entregados fuera de fecha.
                    Muestra además la apertura de cada uno en cantidad de pedidos entregados fuera de fecha y no entregados.
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <empresa-select v-model="d.empresa"></empresa-select>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-text-field name="limit" label="Mostrar" v-model="d.limit"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import moment from 'moment'

    export default {
        components: {empresaSelect},
        data() {
            return {
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                d: {
                    epresa: '',
                    desde: moment().subtract(1, 'day').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD'),
                    limit: 10
                },
                chart: {},
                chartOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        height: '50%'
                    },
                    plotOptions: {
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f} %)',
                            connectorColor: 'silver'
                        },

                    },
                    title: {
                        text: 'Incumplimiento de Entrega de Proveedores'
                    },
                    tooltip: {
                        pointFormat: '<span>{point.name}</span>: <b>{point.value}</b><br/>',
                        shared: false
                    },
                    series: [{
                        type: "sunburst",
                        allowDrillToNode: true,
                        cursor: 'pointer',
                        data: [],
                        levels: [
                            {
                                level: 1,
                                levelIsConstant: false,
                                dataLabels: {
                                    filter: {
                                        property: 'outerArcLength',
                                        operator: '>',
                                        value: 64
                                    }
                                }
                            },
                            {level: 2, colorByPoint: true},
                        ]
                    }]
                }
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/abc-inc-entr', this.d)
                    .then(r => {
                        this.chartOptions.series[0].data = r.data;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/abc-inc-entr.vue